import {Button, Grid} from "@mui/material";
import {styled} from "@mui/system";
import {apiChangePassword} from "api/appApi";
import {TextInput} from "components/Input/FormControl";
import {Form, Formik} from "formik";
import {useDispatch, useSelector} from "react-redux";

const ChangePasswordModalContainer = styled("div")(({theme}) => ({
    padding: "24px 48px ",
}));

const SumbmitButton = styled(Button)(({theme}) => ({
    height: "44px",
}));

const ChangePasswordModal = () => {
    //@ts-ignore
    const token = useSelector((state) => state).userReducer.user.token;
    const dispatch = useDispatch();
    const onSubmit = (values: any) => {
        // @ts-ignore
        dispatch(apiChangePassword(values, token));
    };

    const initialValues = {
        red: "blue",
    };

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {(formik) => (
                <Form>
                    <ChangePasswordModalContainer>
                        <Grid container>
                            <Grid sx={{marginBottom: "26px"}} item xs={12}>
                                <TextInput isPassword={true} name="oldPassword" label="رمز عبور فعلی"/>
                            </Grid>
                            <Grid sx={{marginBottom: "26px"}} item xs={12}>
                                <TextInput isPassword={true} name="password" label="رمز عبور جدید"/>
                            </Grid>
                            <Grid sx={{marginBottom: "52px"}} item xs={12}>
                                <TextInput isPassword={true} name="confirmPassword" label="تکرار رمز عبور"/>
                            </Grid>
                            <Grid item xs={12}>
                                <SumbmitButton
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    disableElevation
                                    startIcon={
                                        <svg
                                            width="17"
                                            height="20"
                                            viewBox="0 0 17 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M14.3335 0H2.72925C1.78417 0 0.954346 0.777477 0.954346 1.69775V18.8639C0.954346 19.172 1.04008 19.4287 1.17826 19.6271C1.34351 19.8642 1.60958 20.0001 1.8949 20C2.16465 20 2.45186 19.8799 2.71708 19.6534L7.90881 15.2453C8.06916 15.1084 8.29948 15.0299 8.53896 15.0299C8.77834 15.0299 9.0082 15.1084 9.16902 15.2457L14.3434 19.6527C14.6096 19.8799 14.877 20.0001 15.1462 20.0001C15.6016 20.0001 16.0455 19.6488 16.0455 18.864V1.69775C16.0455 0.777477 15.2786 0 14.3335 0Z"
                                                fill="white"
                                            />
                                            <rect x="4.33325" y="5" width="9.16667" height="1.25" rx="0.625"
                                                  fill="#1062D0"/>
                                        </svg>
                                    }
                                    endIcon={
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M14.3582 10.0355C13.9738 9.85281 13.5817 9.69543 13.1827 9.56359C14.475 8.59359 15.3125 7.04902 15.3125 5.3125C15.3125 2.3832 12.9293 0 9.99998 0C7.07065 0 4.68748 2.3832 4.68748 5.3125C4.68748 7.05094 5.52686 8.59703 6.82158 9.56684C5.63533 9.95738 4.52225 10.5651 3.54803 11.3664C1.76162 12.8358 0.519555 14.8854 0.0506881 17.1376C-0.096265 17.8433 0.0797896 18.5682 0.533617 19.1262C0.985219 19.6815 1.65487 20 2.3708 20H11.9922C12.4236 20 12.7734 19.6502 12.7734 19.2188C12.7734 18.7873 12.4236 18.4375 11.9922 18.4375H2.3708C2.03729 18.4375 1.83608 18.2513 1.74584 18.1404C1.59002 17.9488 1.52971 17.6994 1.58037 17.4561C2.39112 13.5617 5.82611 10.717 9.79287 10.621C9.86158 10.6237 9.9306 10.625 9.99998 10.625C10.07 10.625 10.1397 10.6236 10.2091 10.6209C11.4247 10.6495 12.5939 10.9269 13.6874 11.4467C14.0771 11.6319 14.5431 11.4662 14.7284 11.0765C14.9136 10.6868 14.7479 10.2207 14.3582 10.0355ZM10.1905 9.0577C10.1271 9.05656 10.0636 9.05598 9.99998 9.05598C9.93693 9.05598 9.87389 9.0566 9.81092 9.05777C7.83064 8.95898 6.24998 7.31687 6.24998 5.3125C6.24998 3.24473 7.93221 1.5625 9.99998 1.5625C12.0678 1.5625 13.75 3.24473 13.75 5.3125C13.75 7.31637 12.1701 8.95816 10.1905 9.0577Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M19.2188 15.5078H17.0703V13.3594C17.0703 12.9279 16.7205 12.5781 16.2891 12.5781C15.8576 12.5781 15.5078 12.9279 15.5078 13.3594V15.5078H13.3594C12.9279 15.5078 12.5781 15.8576 12.5781 16.2891C12.5781 16.7205 12.9279 17.0703 13.3594 17.0703H15.5078V19.2188C15.5078 19.6502 15.8576 20 16.2891 20C16.7205 20 17.0703 19.6502 17.0703 19.2188V17.0703H19.2188C19.6502 17.0703 20 16.7205 20 16.2891C20 15.8576 19.6502 15.5078 19.2188 15.5078Z"
                                                fill="white"
                                            />
                                        </svg>
                                    }
                                    disableRipple
                                    disableTouchRipple
                                >
                                    &nbsp;&nbsp; ذخیره تغییرات &nbsp;&nbsp;
                                </SumbmitButton>
                            </Grid>
                        </Grid>
                    </ChangePasswordModalContainer>
                </Form>
            )}
        </Formik>
    );
};

export default ChangePasswordModal;
